import { ReactElement, memo } from 'react';
import Tooltip from '@mui/material/Tooltip';

import { useOrderFinalizedStateInfo } from '~hooks/index';

import { OrderFinalizedStateChipProps } from './types';
import { OrderFinalizedStateChipRoot } from './styles';

const OrderFinalizedStateChip = ({
  stateId,
  size = 'medium',
}: OrderFinalizedStateChipProps): ReactElement => {
  const { description, color, tooltipMessage } =
    useOrderFinalizedStateInfo(stateId);

  return (
    <Tooltip title={tooltipMessage} arrow>
      <OrderFinalizedStateChipRoot
        variant="filled"
        label={description}
        color={color}
        size={size}
      />
    </Tooltip>
  );
};

export default memo(OrderFinalizedStateChip);
